export default __webpack_public_path__ + "static/media/financely.88d2a409.PNG";